// Booking v2 (SS-1287). Deliberately its own file: the legacy booking wizard
// keeps client_booking_* bundles and the two flows must not share a key — even
// where the wording is copied from it word for word.
export const ClientBooking = {
  en: {
    'Select location': 'Select location',
    'No locations are open for online booking':
      'No locations are open for online booking',
    'Book personal training': 'Book personal training',
    'Sign up for a group class': 'Sign up for a group class',
    'Join a club event': 'Join a club event',
    'Personal training': 'Personal training',
    'Group class': 'Group class',
    'Club event': 'Club event',
    'Select service': 'Select service',
    'No services are available for online booking here':
      'No services are available for online booking here',
    'Select instructor': 'Select instructor',
    'No specialists are taking online bookings for this service':
      'No specialists are taking online bookings for this service',
    'Show all available options': 'Show all available options',
    'Back to the instructor list': 'Back to the instructor list',
    'No instructor is available on this date':
      'No instructor is available on this date',
    'Select time': 'Select time',
    'No available times for this date': 'No available times for this date',
    'Select class': 'Select class',
    'No classes available for this date': 'No classes available for this date',
    'No events available': 'No events available',
    'No waves available': 'No waves available',
    'Sold out': 'Sold out',
    'More info': 'More info',
    'No description': 'No description',
    'Confirm your booking': 'Confirm your booking',
    locationLabel: 'Location',
    kindLabel: 'Booking type',
    serviceLabel: 'Service',
    instructorLabel: 'Instructor',
    eventLabel: 'Event',
    waveLabel: 'Wave',
    timeLabel: 'Time',
    costLabel: 'Cost',
    Comment: 'Comment',
    'Required field': 'Required field',
    'How would you like to pay?': 'How would you like to pay?',
    'The spot is held for 15 minutes while you pay':
      'The spot is held for 15 minutes while you pay',
    'No payment option is available for this booking':
      'No payment option is available for this booking',
    'Your booking is incomplete — start over':
      'Your booking is incomplete — start over',
    'Some classes are not shown — pick a nearer date':
      'Some classes are not shown — pick a nearer date',
    rollbackIncompleteLink: 'The link is incomplete — continue from this step',
    rollbackUnknownLocation: 'That location is not open for online booking',
    rollbackDateOutOfRange: 'That date is outside the booking window',
    rollbackServiceGone: 'That service is no longer available',
    rollbackSpecialistGone: 'That instructor is no longer taking bookings',
    rollbackSlotGone: 'That time is no longer free — pick another',
    rollbackSessionGone: 'That class is no longer available',
    rollbackEventGone: 'That event is no longer available',
    rollbackWaveGone: 'That wave is no longer available',
    rollbackWaveMissing: 'Pick a wave of this event',
    'Company event': 'Company event',
    'Valid until': 'Valid until',
    'Booking…': 'Booking…',
    'Sign in to finish your booking': 'Sign in to finish your booking',
    'Sign in': 'Sign in',
    'You are booked': 'You are booked',
    'Your booking is confirmed': 'Your booking is confirmed',
    'Go to my bookings': 'Go to my bookings',
    'Book another': 'Book another',
    minutes_one: '{{count}} min',
    minutes_other: '{{count}} min',
    spotsLeft_one: '{{count}} spot left',
    spotsLeft_other: '{{count}} spots left',
    visitsLeft_one: '{{count}} visit left',
    visitsLeft_other: '{{count}} visits left',
  },
  uk: {
    'Select location': 'Оберіть локацію',
    'No locations are open for online booking':
      'Немає локацій, доступних для онлайн-запису',
    'Book personal training': 'Записатися на персональне тренування',
    'Sign up for a group class': 'Записатися на групове заняття',
    'Join a club event': 'Записатися на подію клубу',
    'Personal training': 'Персональне тренування',
    'Group class': 'Групове заняття',
    'Club event': 'Подія клубу',
    'Select service': 'Оберіть послугу',
    'No services are available for online booking here':
      'Тут немає послуг, доступних для онлайн-запису',
    'Select instructor': 'Оберіть спеціаліста',
    'No specialists are taking online bookings for this service':
      'Жоден спеціаліст не приймає онлайн-записи на цю послугу',
    'Show all available options': 'Показати всі доступні варіанти',
    'Back to the instructor list': 'Повернутися до списку спеціалістів',
    'No instructor is available on this date':
      'Немає доступного спеціаліста на цю дату',
    'Select time': 'Оберіть час',
    'No available times for this date': 'На цю дату вільного часу немає',
    'Select class': 'Оберіть заняття',
    'No classes available for this date': 'На цю дату занять немає',
    'No events available': 'Подій немає',
    'No waves available': 'Хвиль немає',
    'Sold out': 'Місць немає',
    'More info': 'Детальніше',
    'No description': 'Опис відсутній',
    'Confirm your booking': 'Підтвердження запису',
    locationLabel: 'Локація',
    kindLabel: 'Тип запису',
    serviceLabel: 'Послуга',
    instructorLabel: 'Спеціаліст',
    eventLabel: 'Подія',
    waveLabel: 'Хвиля',
    timeLabel: 'Час',
    costLabel: 'Вартість',
    Comment: 'Коментар',
    'Required field': "Обов'язкове поле",
    'How would you like to pay?': 'Як бажаєте оплатити?',
    'The spot is held for 15 minutes while you pay':
      'Місце зарезервовано на 15 хвилин до оплати',
    'No payment option is available for this booking':
      'Для цього запису немає доступного способу оплати',
    'Your booking is incomplete — start over':
      'Запис незавершений — почніть спочатку',
    'Some classes are not shown — pick a nearer date':
      'Показано не всі заняття — оберіть ближчу дату',
    rollbackIncompleteLink: 'Посилання неповне — продовжте з цього кроку',
    rollbackUnknownLocation: 'Ця локація недоступна для онлайн-запису',
    rollbackDateOutOfRange: 'Ця дата поза періодом запису',
    rollbackServiceGone: 'Ця послуга більше не доступна',
    rollbackSpecialistGone: 'Цей спеціаліст більше не приймає записи',
    rollbackSlotGone: 'Цей час уже зайнятий — оберіть інший',
    rollbackSessionGone: 'Це заняття більше не доступне',
    rollbackEventGone: 'Ця подія більше не доступна',
    rollbackWaveGone: 'Цієї хвилі більше немає',
    rollbackWaveMissing: 'Оберіть хвилю цієї події',
    'Company event': 'Подія клубу',
    'Valid until': 'Діє до',
    'Booking…': 'Записуємо…',
    'Sign in to finish your booking': 'Увійдіть, щоб завершити запис',
    'Sign in': 'Увійти',
    'You are booked': 'Вас записано',
    'Your booking is confirmed': 'Ваш запис підтверджено',
    'Go to my bookings': 'До моїх записів',
    'Book another': 'Записатися ще',
    minutes_one: '{{count}} хв',
    minutes_few: '{{count}} хв',
    minutes_many: '{{count}} хв',
    minutes_other: '{{count}} хв',
    spotsLeft_one: 'залишилось {{count}} місце',
    spotsLeft_few: 'залишилось {{count}} місця',
    spotsLeft_many: 'залишилось {{count}} місць',
    spotsLeft_other: 'залишилось {{count}} місць',
    visitsLeft_one: 'залишилось {{count}} відвідування',
    visitsLeft_few: 'залишилось {{count}} відвідування',
    visitsLeft_many: 'залишилось {{count}} відвідувань',
    visitsLeft_other: 'залишилось {{count}} відвідувань',
  },
};

export const ClientReservations = {
  en: {
    'My bookings': 'My bookings',
    Book: 'Book',
    Upcoming: 'Upcoming',
    History: 'History',
    'No bookings yet': 'No bookings yet',
    'Show more': 'Show more',
    'Personal training': 'Personal training',
    'Group class': 'Group class',
    'Company event': 'Company event',
    payment_paid: 'Paid',
    payment_pending: 'Payment pending',
    payment_none: 'Not paid',
  },
  uk: {
    'My bookings': 'Мої записи',
    Book: 'Записатися',
    Upcoming: 'Найближчі',
    History: 'Історія',
    'No bookings yet': 'Записів ще немає',
    'Show more': 'Показати ще',
    'Personal training': 'Персональне тренування',
    'Group class': 'Групове заняття',
    'Company event': 'Подія клубу',
    payment_paid: 'Оплачено',
    payment_pending: 'Очікує оплати',
    payment_none: 'Неоплачений',
  },
};
